// extracted by mini-css-extract-plugin
module.exports = {"root":"agreement_root__1i_ZH","text":"agreement_text__2bHXg","btns":"agreement_btns__2Dr9P","btn":"agreement_btn__2LjwZ","btnBack":"agreement_btnBack__XqwCB"};